import { Title } from 'app/agriculture/components/Title/Title';
import { Subtitle } from 'app/agriculture/components/Subtitle/Subtitle';
import { Heading } from 'app/agriculture/components/Heading/Heading';
import { Actions } from 'app/agriculture/components/Actions/Actions';
import { useNavigate } from 'react-router-dom';
import { RoundTable } from 'app/agriculture/components/RoundTable/RoundTable';
import { useUsers } from 'app/agriculture/hooks/users/useUsers';
import { Button } from 'app/agriculture/components/Button/Button';
import { ProfileAvatar } from 'app/agriculture/infobox/common/ProfileAvatar';
import { FarmInvitations } from 'app/agriculture/routes/BackOffice/Settings/components/FarmInvitations';
import { BackOfficeContent } from 'app/agriculture/routes/BackOffice/BackOfficeContent';
import './FarmUsers.scss';

export function FarmUsers() {
    const navigate = useNavigate();
    const users = useUsers();

    return (
        <BackOfficeContent className="FarmUsers">
            <Title>Manage Users</Title>
            <Subtitle>
                Add, remove, or update user access, or send an invite to new team members.
            </Subtitle>
            <Heading>Users</Heading>
            <RoundTable
                columns={{
                    name: { label: 'Name' },
                    email: { label: 'Email' },
                    phone: { label: 'Phone' },
                }}
                rows={users.map(({ id, name = 'Unknown', email, phone }) => ({
                    id,
                    name: (
                        <Button
                            className="FarmUsers__user-name"
                            text={name}
                            startIcon={<ProfileAvatar name={name} size={32} />}
                            variant="textonly"
                            // I imagine this will be clickable one day, but that day is not today
                            disabled
                            // onClick={() => {
                            //     navigate(`${id}`);
                            // }}
                        />
                    ),
                    email,
                    phone: phone ?? '',
                }))}
            />
            <FarmInvitations />
            <Actions
                sticky
                primaryAction={{
                    text: 'Invite Users',
                    onClick: () => {
                        navigate('invite');
                    },
                }}
                backAction={{
                    text: 'Back',
                    onClick: () => {
                        navigate(-1);
                    },
                }}
            />
        </BackOfficeContent>
    );
}
